import { connectTable } from 'custom-table/js/components/DefaultTable/container';
import PlayerStatsTable from '.';

export default connectTable(PlayerStatsTable);
